import { fetchCategoryBanners } from '../../features/categoryBanners/fetchCategoryBanners';
import { useStores } from '../../stores/useStores';

import { useQuery } from './useCustomQuery';

export const useCategoryBannersQuery = (lang: string) => {
  const { eventTriggerStore } = useStores();

  return useQuery({
    queryKey: ['category-banners', lang],
    queryFn: async () => {
      // OFFER/GIFT/MESSAGE eligibility is decided server-side from the login-time event-trigger
      // feed, written to Redis as a side effect of eventTriggerStore's AFTER_LOGIN fetch. Without
      // this, a banner fetch racing ahead of that write silently hides an eligible banner until
      // the next reload. fetch() is singleFlight-wrapped, so this joins an already-in-flight login
      // fetch instead of firing a second one.
      await eventTriggerStore.fetch();
      return fetchCategoryBanners(lang);
    },
  });
};
